import React, { Fragment, memo } from 'react';
import { useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { kitchenAreaApi } from '@app/store';
import { IKitchenArea, KitchenAreaDTO } from '@app/common';
import { Button, Form, Panel } from '@app/components';
import { KitchenAreaForm } from './KitchenAreaForm';
import { useToast, useTriptych } from '@app/hooks';
import { KitchenAreaCard } from './KitchenAreaCard';
import { KitchenAreaFormValues } from './kitchen-area-form.helpers';

export const KitchenAreaCreate = memo(() => {
  const toast = useToast();

  const triptych = useTriptych()

  const [create, { isLoading, error: apiErrors }] = kitchenAreaApi.useCreateOneKitchenAreasMutation();

  const formMethods = useForm<KitchenAreaFormValues>({
    resolver: classValidatorResolver(KitchenAreaDTO),
    defaultValues: {
      name: '',
    },
  });

  const onCreate = async (formValues: Partial<IKitchenArea>) => {
    try {
      const kitchenArea = await create(formValues).unwrap();

      triptych.close({ mode: 'UPDATE', data: kitchenArea });

      toast.success('Votre lieu de fabrication a bien été ajouté.')
    } catch {
      toast.error('Une erreur est survenue lors de la création de votre lieu de fabrication.')
    }
  }

  return (
    <Fragment>
      <KitchenAreaCard
        formMethods={formMethods}
        toggle={() => triptych.toggle()} />

      <Form formMethods={formMethods} apiErrors={apiErrors}>

        <Panel.Content>

          <Panel.FormContainer>

            <KitchenAreaForm />

          </Panel.FormContainer>

          <Panel.Actions>
            <Button
              title="Retour"
              grow
              large
              bordered
              onPress={() => triptych.close()} />

            <Button
              title="Valider"
              loading={isLoading}
              onPress={formMethods.handleSubmit(onCreate)}
              grow
              large />
          </Panel.Actions>

        </Panel.Content>

      </Form>

    </Fragment>
  );
});
